// src/slugify.ts
import { remove as stripAccents } from "diacritics";
function getSafeRegexpString(input) {
  return input.split("").map((char) => `\\${char}`).join("");
}
function format(input, delimiter, ignoreInvalid = false) {
  const harmonized = stripAccents(input).trim().toLowerCase();
  const safeDelimiter = getSafeRegexpString(delimiter);
  if (ignoreInvalid) {
    return harmonized.replace(/\s+/g, delimiter);
  }
  return harmonized.replace(new RegExp(`[^a-z0-9${safeDelimiter}]+`, "g"), delimiter).replace(new RegExp(`${safeDelimiter}+`, "g"), delimiter).replace(new RegExp(`^${safeDelimiter}`, "g"), "").replace(new RegExp(`${safeDelimiter}$`, "g"), "");
}
function slugify(node, options = { delimiter: "-", prefix: "" }) {
  if (!options.delimiter)
    options.delimiter = "-";
  if (!options.prefix)
    options.prefix = "";
  if (!node || typeof node === "boolean") {
    return "";
  }
  const { delimiter, prefix } = options;
  if (typeof node === "boolean") {
    return "";
  }
  if (typeof node === "string" || typeof node === "number") {
    const harmonizedPrefix = format(prefix, delimiter, true);
    const harmonizedNode = format(String(node), delimiter);
    if (harmonizedPrefix) {
      return `${harmonizedPrefix}${delimiter}${harmonizedNode}`;
    }
    return harmonizedNode;
  }
  if ("children" in node) {
    return slugify(node.children);
  }
  if ("type" in node)
    return slugify(node.props.children, options);
  if (Symbol.iterator in node) {
    return slugify(
      Array.from(node).map((subNode) => slugify(subNode, { delimiter })).join(delimiter),
      options
    );
  }
  return "";
}
export {
  slugify as default
};
//# sourceMappingURL=slugify.js.map